import React from "react";
import { Switch, Route, withRouter,Router } from "react-router-dom";
import {Fixture,Performance} from "./Component";
import history from './history';
history.listen((location) => {
    console.log('location', location);
});

function Routes() {
  return (
        <Router history={history}>
            <Switch >
              <Route exact path="/react/tournament/:id/fixtures" component={Fixture} />
              <Route exact path="/react/performance/:academy_id/:player_id/:batch_id" component={Performance} />
            </Switch>
        </Router>
  );
}


export default Routes;